import { render, staticRenderFns } from "./nomination-matrix-select-subtype.vue?vue&type=template&id=8b4a686c&scoped=true"
import script from "./nomination-matrix-select-subtype.vue?vue&type=script&lang=js"
export * from "./nomination-matrix-select-subtype.vue?vue&type=script&lang=js"
import style0 from "./nomination-matrix-select-subtype.vue?vue&type=style&index=0&id=8b4a686c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b4a686c",
  null
  
)

export default component.exports